"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _hooks = require("../../hooks");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  className: '',
  size: 22,
  withBackground: false,
  datasets: {}
};
function Icon(props) {
  const {
    className,
    name,
    size,
    color,
    withBackground,
    datasets,
    onClick
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const dataAttributes = (0, _hooks.useDataset)(datasets);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: "".concat(className, " ").concat(name, " material-icons"),
    size: size,
    color: color,
    "data-type": "icon",
    onClick: onClick,
    withBackground: withBackground
  }, dataAttributes), name);
}
const Container = _styled.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _ref => {
  let {
    theme,
    size,
    color,
    withBackground,
    onClick
  } = _ref;
  const {
    colors
  } = theme;
  let styles = "\n      font-size: ".concat(size, "px;\n      color: ").concat(color || colors.FONT.DESCRIPTION, ";\n    ");
  if (withBackground) {
    const _SUBTRACTED_SIZE_PERCENTAGE = typeof withBackground === 'number' ? withBackground : 0.35; // -- 35%

    styles += "\n        width: ".concat(size, "px;\n        height: ").concat(size, "px;\n        border-radius: 7px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: ").concat(size - size * _SUBTRACTED_SIZE_PERCENTAGE, "px;\n        background-color: ").concat(colors.NEUTRAL.SIDE, ";\n      ");
  }
  if (onClick) {
    styles += 'cursor: pointer;';
  }
  return styles;
});
var _default = exports.default = Icon;